import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, InputAdornment } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Avatar,
  Chip,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  Popover,
  ButtonGroup,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Assignment,
  Group,
  Close,
  ArrowForwardIos,
  CheckCircle,
  Block,
  Receipt,
  DateRange,
  Search,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";

import { Skeleton } from "@material-ui/lab";
import Format from "date-fns/format";
import { DatePicker } from "@material-ui/pickers";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
} from "../../../../../../utils/web_config";
//import { useTransactionTypes } from "../../../../hooks/use_hooks";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function Tracking(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});
  const [transactions, setTransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Write item serial number",
    loading: false,
    toggling: false,
    data: [],
  });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [serial, setSerial] = useState({
    value: '',
    error: "",
  });
  const [range, setRange] = useState(0);

 
  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

  }, []);


  const onSearchValueChange=(e)=>{
    setSerial({value:e.target.value})
  }

  //////////////
  //////////
  const transactionsColums = [
  
    {
      name: "movement",
      label: "Movement",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "serial_number",
      label: "Serial number",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "from2",
      label: "From",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "to2",
      label: "To",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "date",
      label: "Date",
      options: {
        filter: false,
        sort: false,
      },
    },
  
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {["DELIVERED", "PROCESSED", "SOLD"].includes(
                    transactions.data[dataI]?.status
                  ) ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                ["DELIVERED", "PROCESSED", "SOLD"].includes(
                  transactions.data[dataI]?.status
                )
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(transactions.data[dataI]?.status)}
            />
          );
        },
      },
    },
  ];

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search here...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
  };

  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    if (s == null) {
      s = "Unknown";
    }
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  ///////////////////////////////////
  ///////////////////////////////////

  const getTransactions = () => {
    const createInstance = axios.create(new AdminService().getHeaders(accountData.token));

    setTransactions({ ...transactions, loading: true });

    console.log("getting history.....");

    const data = {"serial_number" : serial.value}

    createInstance
      .post(new ReportingService().ITEM_TRACK, data)
      .then(function (response) {
        setTransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setTransactions({
            ...transactions,
            data: d.data,
            status: "There are no movements available for selected date range",
          });
        } else {

          var newData=[]

          d.data.map((d,i)=>{

            var d1={}

            d1={...d,from2:d.from.organization_name,to2:d.to.organization_name}
            newData.push(d1)

          })
          
          setTransactions({
            ...transactions,
            data: newData,
           
          });
        }
      })
      .catch(function (error) {
        setTransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}
    
      {/* ////////////////////////////// */}

      <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h6" className={classes.title}>
            <b>{range==0?"Track items":'Track batches'}</b>
          </Typography>
         <ButtonGroup color='primary'>
           <Button disableElevation className={classes.btn} variant={range==0?'contained':'outlined'} onClick={()=>setRange(0)}>Item</Button>
           <Button disableElevation className={classes.btn} variant={range==1?'contained':'outlined'}  onClick={()=>setRange(1)}>Batch</Button>
         </ButtonGroup>
        </Box>
      <Grid container>
      <Grid item xs={12} md={6}>
        <Box pt={2} pb={1}>
      
      <Box mt={1} display='flex'>
            <TextField
              size="small"
              variant="outlined"
              placeholder={range==0?"Enter item serial number here":'Enter batch number here'}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={onSearchValueChange}
            />
            <Box ml={1}/>
            <Button color='primary' variant='outlined' onClick={()=>{
              if(range==0){
              getTransactions()
              }else{
                notify("info","Not implemented yet")
              }

              }}>Search</Button>
          </Box>

        
</Box>
      </Grid>
      <Grid item xs={12} md={12}>
     
      {transactions.loading && <LinearProgress />}
      <MUIDataTable
        title=""
        data={transactions.data}
        columns={transactionsColums}
        options={transactionsOptions}
      />
     
      </Grid>
      </Grid>
   
    </div>
  );
}

export default withLocalize(Tracking);
